<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading || !loaded }"
      @click.stop>
      <h3 class="text-center">
        Add {{ itemType }}
      </h3>

      <validation-observer ref="handler-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="id"
              v-slot="{ errors }">
              <label for="id">Handler:</label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="handlers"
                  v-model="data.id"
                  :reduce="handler => handler.id"
                  :filterBy="filterByHandlers"
                  placeholder="Select an handler"
                  label="name"
                  @search="debouncedFetchHandlers">
                  <template slot="no-options">
                    <template v-if="!emptyResults">Search in progress&hellip;</template>
                    <template v-if="emptyResults">There are no handlers for the provided phrase&hellip;</template>
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'HandlerPopup',
  data () {
    return {
      isVisible: false,
      loaded: false,
      loading: false,
      handlers: [],
      emptyResults: false,
      loadError: false,
      itemType: false,
      data: {
        id: null,
        reference_id: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-handler-popup', this.show);
  },
  methods: {
    loadData () {
      let paramsData = {};

      if (this.data.referenceType === 'COUNTRY') {
        paramsData['where'] = {
          type: 'AGENT'
        };
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: '/handlers/items',
        outputKey: 'handlers',
        params: paramsData,
        loadedKey: 'loaded',
        errorKey: 'loadError'
      });
    },
    filterByHandlers (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    show (referenceType = false, referenceId = false, itemType = false) {
      this.loaded = false;
      this.itemType = itemType;
      this.loadData();

      this.data = {
        id: null,
        reference_id: referenceId,
        reference_type: referenceType
      };

      setTimeout(() => {
        this.$refs['handler-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['handler-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointBase = '';

      if (this.data.reference_type === 'AIRPORT') {
        endpointBase = 'airports';
      } else if (this.data.reference_type === 'COUNTRY') {
        endpointBase = 'countries';
      }

      let endpointUrl = endpointBase + '/add-handler/' + this.data.reference_id;
      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.itemType + ' added',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the ' + this.itemType + '. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('handlers-list-reload');

          if (this.data.reference_type === 'AIRPORT') {
            this.$bus.$emit('airports-list-reload');
          }
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        handler_id: this.data.id
      };

      return dataToSend;
    },
    fetchHandlers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/handlers/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.data.referenceType === 'COUNTRY') {
        paramsData.where.type = 'AGENT';
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'handlers',
        errorKey: 'loadError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchHandlers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchHandlers(searchPhrase, loadingCallback);
    }, 500)
  },
  beforeDestroy () {
    this.$bus.$off('show-handler-popup', this.show);
  }
}
</script>
